<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-9">
                    <button
                        type="button"
                        @click="showBody(0)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Lista
                    </button>
                    <button
                        v-if="create"
                        type="button"
                        @click="showCreate()"
                        :class="[
                            'btn btn-outline-primary',
                            page == 1 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Agregar
                    </button>
                    <button
                        type="button"
                        @click="showBody(3)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 3 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Ordenar
                    </button>
                </div>
                <div class="col-md-3">
                    <span style="font-size: 20px"
                        >Fuentes de financiamiento</span
                    >
                </div>
            </div>
            <div>
                <phase-list-component
                    v-if="page == 0"
                    @canCreate="create2"
                    v-bind:model_id="model_id"
                    @change="callChangeList"
                ></phase-list-component>
                <phase-form-component
                    v-if="page == 1"
                    v-bind:model_id="phase_id"
                    @change="callChangeCreate"
                    :key="componentKey"
                ></phase-form-component>
                <phase-form-component
                    v-if="page == 2"
                    v-bind:model_id="phase_id"
                ></phase-form-component>
                <phase-order-component
                    v-if="page == 3"
                    v-bind:model_id="model_id"
                ></phase-order-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            phase_id: 0,
            componentKey: 1,
            create: null,
        };
    },
    methods: {
        showCreate() {
            this.phase_id = 0;
            this.page = 1;
            this.componentKey += 1;
        },
        showBody(value) {
            this.page = value;
            this.phase_id = 0;
        },
        callChangeCreate() {
            this.page = 0;
            this.phase_id = 0;
        },
        callChangeList(id) {
            this.phase_id = id;
            this.page = 2;
        },
        create2(create) {
            this.create = create;
        },
    },
    mounted() {},
};
</script>
